import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Survey from "./pages/Survey";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";
import AdminContent from "./pages/AdminContent";
import AdminTeam from "./pages/AdminTeam";
import Login from "./pages/Login";
import HomeownerLogin from "./pages/HomeownerLogin";
import Portal from "./pages/Portal";
import PricingPage from "./pages/PricingPage";
import AdminPricing from "./pages/AdminPricing";
import AdminSubmissionWorkflow from "./pages/AdminSubmissionWorkflow";
import AdminInbox from "./pages/AdminInbox";
import SharedReport from "./pages/SharedReport";
import ProtectedRoute from "./pages/ProtectedRoute";
import { AuthProvider } from "./pages/AuthContext";
import { HomeownerAuthProvider } from "./pages/HomeownerAuthContext";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <HomeownerAuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/survey" element={<Survey />} />
              <Route path="/portal/:id" element={<Portal />} />
              <Route path="/portal/:id/report" element={<Portal />} />
              <Route path="/portal/:id/welcome" element={<Portal />} />
              <Route path="/shared/report/:token" element={<SharedReport />} />
              <Route path="/portal/:id/pricing" element={<PricingPage />} />
              <Route path="/portal-login" element={<HomeownerLogin />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/admin/pricing"
                element={
                  <ProtectedRoute>
                    <AdminPricing />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/content"
                element={
                  <ProtectedRoute>
                    <AdminContent />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/team"
                element={
                  <ProtectedRoute>
                    <AdminTeam />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/submissions/:id"
                element={
                  <ProtectedRoute>
                    <AdminSubmissionWorkflow />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/inbox"
                element={
                  <ProtectedRoute>
                    <AdminInbox />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </HomeownerAuthProvider>
      </AuthProvider>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
